export function DEFAULT_STATE () {
  return {
    disableNavigationGuards: false,
    disableCampaignService: false,
    disableResponseTap: false,
    disableChatDelay: false,
    isOfficeOpen: null,
    enableQuestionatorPreview: false
  }
}

export const state = DEFAULT_STATE()

export const mutations = {
  setDisableNavigationGuards (state, disableNavigationGuards) {
    state.disableNavigationGuards = disableNavigationGuards
  },

  setDisableChatDelay (state, disableChatDelay) {
    state.disableChatDelay = disableChatDelay
  },

  setDisableCampaignService (state, disableCampaignService) {
    state.disableCampaignService = disableCampaignService
  },

  setDisableResponseTap (state, disableResponseTap) {
    state.disableResponseTap = disableResponseTap
  },

  setIsOfficeOpen (state, isOfficeOpen) {
    state.isOfficeOpen = isOfficeOpen
  },

  setQuestionatorPreview (state, value) {
    state.enableQuestionatorPreview = value
  },

  resetState (state) {
    Object.assign(state, DEFAULT_STATE())
  }
}
